// ============================================================
// WHERE A TEAM ARRIVES (plan scene-editor-library, B; ruling 2026-10-20)
// ============================================================
// "Arrivals for": which point a click in Deploy plants - Everyone (the
// main marker) or one team's own arrival point. A team with a point of
// its own rings there at a cut and when added at the table; everyone
// else at the main marker. Remove takes a team's point away again.
//
// Not the team STAMP beside it (TeamField): that says which side
// newcomers JOIN; this says where a side ARRIVES.

import common from '../../styles/common.module.css';
import styles from '../../styles/Battlefield.module.css';

/** "x, z" to one decimal, as the bar's own readout writes a place. */
const where = (point) => `${point.x.toFixed(1)}, ${point.z.toFixed(1)}`;

/**
 * The picker and, for a chosen team, where its point is and Remove.
 *
 * @param {{ teams: { tag: string, label?: string }[], arrivals: Record<string, { x: number, z: number }>,
 *   plantFor: string | null, onPlantFor(tag: string | null): void, onRemove(tag: string): void }} props
 */
export default function ArrivalsFor({ teams, arrivals = {}, plantFor, onPlantFor, onRemove }) {
  const chosen = plantFor ? teams.find((t) => t.tag === plantFor) : null;
  const point = plantFor ? arrivals[plantFor] : null;
  const name = (t) => t.label || t.tag;
  return (
    <>
      <label className={common.label}>
        Arrivals for
        <select
          className={common.input}
          data-testid="deploy-arrival-for"
          value={plantFor ?? ''}
          title="Which point a click plants: the main marker, or where one team arrives"
          onChange={(e) => onPlantFor(e.target.value || null)}
        >
          <option value="">Everyone</option>
          {teams.map((t) => (
            <option key={t.tag} value={t.tag}>
              {name(t)}
              {arrivals[t.tag] ? ' · placed' : ''}
            </option>
          ))}
        </select>
      </label>
      {chosen && (
        <span className={styles.readoutHint} data-testid="deploy-arrival-where">
          {point ? `${name(chosen)} arrive at ${where(point)}` : `Click the map where ${name(chosen)} arrive.`}
        </span>
      )}
      {chosen && point && (
        <button
          type="button"
          className={common.btnSmall}
          data-testid="deploy-arrival-remove"
          title={`${name(chosen)} arrive at the main marker again`}
          onClick={() => onRemove(plantFor)}
        >
          Remove
        </button>
      )}
    </>
  );
}
